module.exports = __webpack_public_path__ + "ba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/ba.svg
// module id = 691
// module chunks = 0